export default {
  'primary': '#FCAF26',
  'secondary': '#9B9B9B',
  'accent': '#FCAF26'
}
